var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "M15.86 5.19c-.01 0-1.18.33-2.82.13a6.03 6.03 0 0 1-2.75-1.1A8.23 8.23 0 0 0 8.12 3.2c-1.93-.52-4.5.14-4.62.17L3 3.5V17h1.35V4.56a8.4 8.4 0 0 1 3.42-.06c.7.18 1.24.52 1.82.87a7.6 7.6 0 0 0 3.3 1.29c1.01.13 1.96.07 2.5-.02v7.03a8.7 8.7 0 0 1-2.34.03c-1.2-.14-1.96-.67-2.75-1.17-.64-.4-1.3-.82-2.18-1.06a7.85 7.85 0 0 0-2.7-.15v1.36c.93-.1 1.75-.07 2.35.09.68.18 1.24.53 1.82.9.84.53 1.8 1.18 3.29 1.37a8.7 8.7 0 0 0 3.36-.19l.5-.13V4.93l-.88.26Z"
  })));
};
export default SvgFlag;